import { render, staticRenderFns } from "./IpRadioSetting.vue?vue&type=template&id=40981790&scoped=true"
import script from "./IpRadioSetting.vue?vue&type=script&lang=js"
export * from "./IpRadioSetting.vue?vue&type=script&lang=js"
import style0 from "./IpRadioSetting.vue?vue&type=style&index=0&id=40981790&prod&scoped=true&lang=css"
import style1 from "./IpRadioSetting.vue?vue&type=style&index=1&id=40981790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40981790",
  null
  
)

export default component.exports